import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59bdd7ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择背景色", -1))
const _hoisted_3 = { style: {"display":"inline-flex"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "选择图标", -1))
const _hoisted_5 = { class: "icon-select" }

export function render(_ctx, _cache) {
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_color_picker = _resolveComponent("el-color-picker")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_org_picker = _resolveComponent("org-picker")

  return (_openBlock(), _createElementBlock("div", {
    class: "base-setup",
    onClick: _cache[8] || (_cache[8] = $event => (_ctx.showIconSelect = false))
  }, [
    _createVNode(_component_el_form, {
      ref: "baseSetting",
      model: _ctx.setup,
      "label-position": "top",
      "label-width": "80px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "表单图标" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, {
              size: "3.5em",
              style: _normalizeStyle('background:' + _ctx.setup.logo.background)
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.setup.logo.icon)))
              ]),
              _: 1
            }, 8, ["style"]),
            _createElementVNode("span", _hoisted_1, [
              _createElementVNode("span", null, [
                _hoisted_2,
                _createVNode(_component_el_color_picker, {
                  modelValue: _ctx.setup.logo.background,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.setup.logo.background) = $event)),
                  "show-alpha": "",
                  size: "default",
                  predefine: _ctx.colors
                }, null, 8, ["modelValue", "predefine"])
              ]),
              _createElementVNode("span", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_el_popover, {
                  placement: "bottom-start",
                  width: "390",
                  trigger: "click"
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_icon, { size: "2em" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.setup.logo.icon)))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (i, id) => {
                        return (_openBlock(), _createBlock(_component_el_icon, {
                          size: "4em",
                          key: id,
                          onClick: $event => (_ctx.setup.logo.icon = i)
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(i)))
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "模版/表单名称",
          rules: _ctx.getRule('请输入模版/表单名称'),
          prop: "formName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.setup.formName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.setup.formName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_el_form_item, {
          label: "模版分组",
          rules: _ctx.getRule('请选择模版分组'),
          prop: "groupId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "select-u",
              modelValue: _ctx.setup.groupId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.setup.groupId) = $event)),
              "value-key": "name",
              placeholder: "请选择模版分组"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fromGroup, (op, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: op.name,
                    value: op.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_el_form_item, {
          label: "模版备注",
          rules: _ctx.getRule('请输入模版备注'),
          prop: "remark"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              rows: "3",
              modelValue: _ctx.setup.remark,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.setup.remark) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_el_form_item, {
          label: "消息通知方式",
          rules: _ctx.getRule('请选择消息通知方式')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.setup.settings.notify.types,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.setup.settings.notify.types) = $event)),
              "value-key": "name",
              placeholder: "选择消息通知方式",
              style: {"width":"30%"},
              clearable: "",
              multiple: "",
              "collapse-tags": ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifyTypes, (wc, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: wc.name,
                    key: index,
                    value: wc
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: _ctx.setup.settings.notify.title,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.setup.settings.notify.title) = $event)),
              style: {"flex":"1","margin-left":"10px"},
              placeholder: "消息通知标题"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["rules"]),
        _createVNode(_component_el_form_item, { label: "谁可以管理此模版" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.setup.settings.admin,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.setup.settings.admin) = $event)),
              onClick: _cache[7] || (_cache[7] = $event => (_ctx.selectUser('admin'))),
              "value-key": "name",
              class: "select-u",
              placeholder: "请选择可以管理此模版的人员",
              style: {"width":"100%"},
              clearable: "",
              multiple: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setup.settings.admin, (wc, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: wc.name,
                    key: index,
                    value: wc
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_org_picker, {
      title: "请选择可以管理此模版的人员",
      multiple: "",
      ref: "orgPicker",
      selected: _ctx.select,
      onOk: _ctx.selected
    }, null, 8, ["selected", "onOk"])
  ]))
}